import { CentralSystemStatus } from '@energy-stacks/broker/feature-system-preferences-data';
import { ConnectorModel } from './connectorModel';

export interface ChargingStationModel {
  identityKey: string;
  serialNumber: string;
  model: string;
  name: string;
  geolocation: GeoLocation;
  location: ChargingSite;
  firmware: string;
  csmsUuid: string;
  centralSystemStatus: CentralSystemStatus;
  ocppProtocol: string;
  dateCreated: string | null;
  connectors: ConnectorModel[];
  online: ChargingStationOnlineStatus;
  csStatus: ChargingStationStatus;
  shadowSerialNumber: string;
}

interface GeoLocation {
  latitude: string;
  longitude: string;
}

export interface ChargingSite {
  uuid: string;
  name: string;
}

const chargingStationConnectivityStatuses = [
  'online',
  'offline',
  'provisioned',
] as const;

export type ChargingStationOnlineStatus =
  (typeof chargingStationConnectivityStatuses)[number];

export const chargingStationStatuses = [
  'undefined',
  'available',
  'preparing',
  'charging',
  'occupied',
  'suspendedEVSE',
  'suspendedEV',
  'finishing',
  'reserved',
  'unavailable',
  'faulted',
  'provisioned',
] as const;
export type ChargingStationStatus = (typeof chargingStationStatuses)[number];
